import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@suraasa/placebo-ui"
import { PlaySolid } from "iconoir-react"
import { useEffect, useRef, useState } from "react"

type Props = {
  open: boolean
  handleClose: () => void
}
const AceInterviewVideo = ({ open, handleClose }: Props) => {
  const ref = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  useEffect(() => {
    const handlePlay = () => setIsPlaying(true)

    // Somehow ref.current is null when the component mounts
    setTimeout(() => {
      ref.current?.addEventListener("play", handlePlay)
      ref.current?.focus()
    }, 1000)

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ref.current?.removeEventListener("play", handlePlay)
    }
  }, [open])

  return (
    <Sheet open={open} onOpenChange={handleClose}>
      <SheetContent height={98}>
        <SheetHeader>
          <SheetTitle>Ace Your Interviews!</SheetTitle>
        </SheetHeader>
        <SheetBody className="flex grow flex-col">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <div
            className="relative"
            onClick={() => {
              setIsPlaying(true)
            }}
          >
            {!isPlaying && (
              <span className="pointer-events-none absolute left-1/2 top-1/2 z-10 flex size-12 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-black/80">
                <PlaySolid className="size-6 text-white" />
              </span>
            )}
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              ref={ref}
              onContextMenu={e => e.preventDefault()}
              poster="https://assets.suraasa.com/lms/profile-assets/ace-interviews-video-cover.png"
              src="https://assets.suraasa.com/lms/profile-assets/ace-interviews-video.mp4"
              playsInline
              controls
              controlsList="nodownload"
            />
          </div>
        </SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default AceInterviewVideo
